import {
  type IconSet,
  IconNameEnum,
  defaultIcons,
} from "@b2bportal/core-themes";
import { hotelAmenitiesIcon } from "@hsbc/portal";
import AirConditioning from "../assets/icons/air-conditioning.svg?react";
import AirplaneArrival from "../assets/icons/airplane-arrive.svg?react";
import AirplaneDeparture from "../assets/icons/airplane-departure.svg?react";
import Airplane from "../assets/icons/airplane.svg?react";
import ArrowRight from "../assets/icons/arrow-right.svg?react";
import user from "../assets/icons/b2b-user.svg?react";
import DownTrendArrow from "../assets/icons/bearish-market.svg?react";
import BedFilled from "../assets/icons/bed-filled.svg?react";
import Block from "../assets/icons/block.svg?react";
import PredictionDanger from "../assets/icons/bullish-market.svg?react";
import Calendar from "../assets/icons/calendar.svg?react";
import Car from "../assets/icons/car.svg?react";
import CashBag from "../assets/icons/cash-bag.svg?react";
import Cash from "../assets/icons/cash.svg?react";
import Charge from "../assets/icons/Charge.svg?react";
import CheckFilled from "../assets/icons/check-filled.svg?react";
import CheckSkinny from "../assets/icons/check-skinny.svg?react";
import Check from "../assets/icons/Check.svg?react";
import ChevronDown from "../assets/icons/chevron-down.svg?react";
import ChevronLeft from "../assets/icons/chevron-left.svg?react";
import ChevronRightLight from "../assets/icons/chevron-right-light.svg?react";
import ChevronRight from "../assets/icons/Chevron.svg?react";
import Clear from "../assets/icons/clear.svg?react";
import ClockFace from "../assets/icons/clock-face.svg?react";
import Clock from "../assets/icons/clock.svg?react";
import Close from "../assets/icons/Close.svg?react";
import CustomerSupport from "../assets/icons/customer-support.svg?react";
import CVV from "../assets/icons/cvv.svg?react";
import PredictionNormal from "../assets/icons/direction-switch.svg?react";
import DisruptionOriginSegmentIcon from "../assets/icons/disruption-origin-segment.svg?react";
import Drawer from "../assets/icons/drawer.svg?react";
import Edit from "../assets/icons/edit.svg?react";
import Error from "../assets/icons/error.svg?react";
import Faq from "../assets/icons/faq.svg?react";
import FilledInfo from "../assets/icons/filled-info.svg?react";
import Filters from "../assets/icons/filters.svg?react";
import FintechInfo from "../assets/icons/fintech-info.svg?react";
import FintechWarning from "../assets/icons/fintech-warning.svg?react";
import Generic from "../assets/icons/GenericFareDetail.svg?react";
import Glass from "../assets/icons/glass.svg?react";
import Guest from "../assets/icons/guest.svg?react";
import Help from "../assets/icons/help.svg?react";
import Hotel from "../assets/icons/hotel.svg?react";
import House from "../assets/icons/house.svg?react";
import Info from "../assets/icons/Info.svg?react";
import Location from "../assets/icons/location.svg?react";
import luggage from "../assets/icons/luggage.svg?react";
import MapPin from "../assets/icons/map-pin.svg?react";
import Minus from "../assets/icons/minus.svg?react";
import CancelForAnyReason from "../assets/icons/money-circle-arrow.svg?react";
import PredictionWarning from "../assets/icons/normal-market.svg?react";
import NotAllowed from "../assets/icons/not-allowed.svg?react";
import Passengers from "../assets/icons/passengers.svg?react";
import Phone from "../assets/icons/phone.svg?react";
import Plus from "../assets/icons/plus.svg?react";
import PriceBreakdown from "../assets/icons/price-breakdown.svg?react";
import PricePrediction from "../assets/icons/price-prediction.svg?react";
import Search from "../assets/icons/search.svg?react";
import Send from "../assets/icons/send.svg?react";
import DisruptionProtection from "../assets/icons/shield-check.svg?react";
import Sort from "../assets/icons/sort.svg?react";
import TriangleDown from "../assets/icons/triangle-down.svg?react";
import Trips from "../assets/icons/trips.svg?react";
import Unavailable from "../assets/icons/Unavailable.svg?react";
import Wallet from "../assets/icons/wallet.svg?react";
import WarningCircle from "../assets/icons/warning-circle.svg?react";
import Warning from "../assets/icons/warning.svg?react";
import WatchedTrips from "../assets/icons/watched-trips.svg?react";
import TenantLogo from "../assets/images/logo.svg?react";

/*
 * NEED TO ADD TENANT SPECIFIC ICONS?
 * Add enum to `app/src/types/tenantIcons` then add icon here.
 */
export const lightModeIcons: IconSet = {
  [IconNameEnum.upTrendArrow]: PredictionDanger,
  [IconNameEnum.downTrendArrow]: DownTrendArrow,
  [IconNameEnum.airConditioning]: AirConditioning,
  [IconNameEnum.bedFilled]: BedFilled,
  [IconNameEnum.info]: Info,
  [IconNameEnum.infoFilled]: FilledInfo,
  [IconNameEnum.dropdownTriangle]: TriangleDown,
  [IconNameEnum.dropdownArrow]: ChevronDown,
  [IconNameEnum.backIcon]: ChevronLeft,
  [IconNameEnum.actionIcon]: ChevronRight,
  [IconNameEnum.checkFilled]: CheckFilled,
  [IconNameEnum.chevronDown]: ChevronDown,
  [IconNameEnum.chevronRightLight]: ChevronRightLight,
  [IconNameEnum.fareDetailsAvailable]: CheckFilled,
  [IconNameEnum.fareDetailsUnavailable]: Unavailable,
  [IconNameEnum.fareDetailsCharge]: Charge,
  [IconNameEnum.fareDetailsGeneric]: Generic,
  [IconNameEnum.filter]: Filters,
  [IconNameEnum.close]: Close,
  [IconNameEnum.nextIcon]: ChevronRight,
  [IconNameEnum.airplane]: Airplane,
  [IconNameEnum.check]: Check,
  [IconNameEnum.clear]: Clear,
  [IconNameEnum.calendar]: Calendar,
  [IconNameEnum.car]: Car,
  [IconNameEnum.plus]: Plus,
  [IconNameEnum.phone]: Phone,
  [IconNameEnum.minus]: Minus,
  [IconNameEnum.calendarSeparatorIcon]: ArrowRight,
  [IconNameEnum.help]: Help,
  [IconNameEnum.hotel]: Hotel,
  [IconNameEnum.house]: House,
  [IconNameEnum.mapPin]: MapPin,
  [IconNameEnum.luggage]: luggage,
  [IconNameEnum.location]: Location,
  [IconNameEnum.searchForFlights]: Glass,
  [IconNameEnum.search]: Search,
  [IconNameEnum.guest]: Guest,
  [IconNameEnum.user]: user,
  [IconNameEnum.passengerSelection]: Passengers,
  [IconNameEnum.edit]: Edit,
  [IconNameEnum.error]: Error,
  [IconNameEnum.warningCircle]: WarningCircle,
  [IconNameEnum.pricePrediction]: PricePrediction,
  [IconNameEnum.predictionNormal]: PredictionNormal,
  [IconNameEnum.predictionWarning]: PredictionWarning,
  [IconNameEnum.predictionDanger]: PredictionDanger,
  [IconNameEnum.priceBreakdown]: PriceBreakdown,
  [IconNameEnum.sort]: Sort,
  [IconNameEnum.send]: Send,
  [IconNameEnum.drawer]: Drawer,
  [IconNameEnum.clockFace]: ClockFace,
  [IconNameEnum.cash]: Cash,
  [IconNameEnum.trips]: Trips,
  [IconNameEnum.wallet]: Wallet,
  [IconNameEnum.faq]: Faq,
  [IconNameEnum.watchedTrips]: WatchedTrips,
  [IconNameEnum.customerSupport]: CustomerSupport,
  [IconNameEnum.cvv]: CVV,
  [IconNameEnum.cancelForAnyReason]: CancelForAnyReason,
  [IconNameEnum.checkBulletPoint]: CheckSkinny,
  [IconNameEnum.informational]: NotAllowed,
  [IconNameEnum.warning]: Warning,
  [IconNameEnum.importantInformation1]: Info,
  [IconNameEnum.importantInformation2]: Block,
  [IconNameEnum.importantInformation3]: Info,
  [IconNameEnum.importantInformation4]: Info,
  [IconNameEnum.tenantLogo]: TenantLogo,
  [IconNameEnum.disruptionProtection]: DisruptionProtection,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineOne]: FintechWarning,
  [IconNameEnum.disruptionHowItWorksDialogInfoLineTwo]: FintechInfo,
  [IconNameEnum.airplaneArrival]: AirplaneArrival,
  [IconNameEnum.airplaneDeparture]: AirplaneDeparture,
  [IconNameEnum.clock]: Clock,
  [IconNameEnum.disruptionOriginSegmentIcon]: DisruptionOriginSegmentIcon,
  [IconNameEnum.cashBag]: CashBag,
};

export const darkModeIcons: IconSet = {
  ...defaultIcons,
  ...lightModeIcons,
};

export const icons: IconSet = {
  ...defaultIcons,
  ...lightModeIcons,
  hotelAmenities: hotelAmenitiesIcon,
};

export default icons;
